<div class="b-page b-container">
  <h1 class="b-page-title">About <br class="d-block d-sm-none">BrainKey</h1>

  <section class="general-info">
    <p>
    Neuroscientists built BrainKey to ensure a healthier future for the world’s most complex organ - the human brain.<br><br>
    BrainKey's long-term mission is to unlock better future treatments for the 1+ billion people suffering from debilitating neurological and other brain disorders.
    </p>
  </section>

  <section class="leadership">
    <h2 class="b-page-subtitle">Leadership Team</h2>

    <div class="quote">
      <div class="d-flex align-items-center align-items-sm-start">
        <div class="quote__image">
          <img src="/assets/images/about-brainkey/team/Owen-Philips.webp" alt="">
        </div>
        <div class="quote__author--mobile d-block d-sm-none">
          <div class="quote__name">
            Owen Philips, PhD
          </div>
          <div class="quote__position">
            Neuroscientist<br>Founder & CEO
          </div>
          <div class="quote__socials">
            <div class="quote__social">
              <a href="https://www.linkedin.com/in/owenrobertphillips/" target="_blank">
                <img src="/assets/images/socials/linkedin-icon--black.svg" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="quote__text">
        <p>
          “My mom had a treatable form of dementia that went undiagnosed for years, leading to a worse outcome than it should have.
          This experience drives us at BrainKey, a company dedicated to transforming how we identify, treat, and manage brain health.
        </p>
        <p>
          At BrainKey, we’re harnessing the power of AI and advanced clinical technologies to provide personalized brain health insights
          through brain MRI and biomedical analysis. Our mission is clear: to equip physicians with the tools they need to prevent
          cognitive decline and create a world where dementia no longer threatens 1 in 3 of us.
        </p>
        <p>
          This mission is deeply personal to me, but it’s also a global challenge—one we’re determined to solve.”
        </p>

        <div class="quote__author d-none d-sm-flex">
          <div class="quote__name">
            -Owen Philips, PhD
          </div>
          <div class="quote__position">
            Neuroscientist, Founder & CEO
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="team-cards">
    <div app-team-member-card
         name="William Ogden Moore"
         title="Business Development"
         imageSrc="/assets/images/about-brainkey/team/William-Ogden-Moore.webp"
         linkedin="https://www.linkedin.com/in/william-ogden-moore-20b4b8b0/"
    ></div>

    <div app-team-member-card
         name="Katharina Koch, PhD"
         title="Product Management"
         imageSrc="/assets/images/about-brainkey/team/Katharina-Koch.webp"
         linkedin="https://www.linkedin.com/in/katharina-koch-clinical-psychologist/"
    ></div>

    <div app-team-member-card
         name="Natalia Del Campo, PhD"
         title="Business Development"
         imageSrc="/assets/images/about-brainkey/team/Natalia-Del-Campo.webp"
         linkedin="https://www.linkedin.com/in/natalia-del-campo-0848217/"
         publications="https://scholar.google.com/citations?user=T5wvGb0AAAAJ&hl=en&oi=sra"
    ></div>

    <div app-team-member-card
         name="Zoe Kuhlken"
         title="Machine Learning Engineer"
         imageSrc="/assets/images/about-brainkey/team/Zoe-Kuhlken.webp"
         linkedin="www.linkedin.com/in/zoë-kuhlken-119873202"
    ></div>

    <div app-team-member-card
         name="Nathan Strong, PhD"
         title="Founder and CTO"
         imageSrc="/assets/images/about-brainkey/team/Nathan-Strong.webp"
         linkedin="https://www.linkedin.com/in/nathan-strong-12781732/"
    ></div>

    <div app-team-member-card
         name="Bianca Aquino"
         title="Client Services"
         imageSrc="/assets/images/about-brainkey/team/Bianca-Aquino.webp"
         linkedin="https://www.linkedin.com/in/bianca-aquino-00038a32/"
    ></div>

    <div app-team-member-card
         name="Kevin Aquino, PhD"
         title="Scientific Director"
         imageSrc="/assets/images/about-brainkey/team/Kevin-Aquino.webp"
         linkedin="https://www.linkedin.com/in/kevin-m-aquino/"
         web="https://kevinaquino.github.io/"
         publications="https://scholar.google.com.au/citations?user=fdlh7U8AAAAJ&hl=en"
    ></div>

    <div app-team-member-card
         name="Daniel J. Valentino, PhD"
         title="Neuroinformatics"
         imageSrc="/assets/images/about-brainkey/team/Daniel-J.-Valentino.webp"
         linkedin="https://www.linkedin.com/in/danielvalentino/"
    ></div>

    <div app-team-member-card
         name="Alyssa Goulding"
         title="Design Lead"
         [hasDefaultBackground]="true"
         imageSrc="/assets/images/about-brainkey/team/Alyssa-Goulding.webp"
         linkedin="https://www.linkedin.com/in/alyssagoulding/"
    ></div>

    <div app-team-member-card
         name="Grace Mellis"
         title="CFO"
         imageSrc="/assets/images/about-brainkey/team/Grace-Mellis.webp"
         linkedin="www.linkedin.com/in/gracemellis"
    ></div>

    <div app-team-member-card
         name="Brittany Holmes, PhD"
         title="Scientific Communication"
         imageSrc="/assets/images/about-brainkey/team/Brittany-Holmes.webp?v=2"
         linkedin="https://www.linkedin.com/in/brittanysholmes/"
    ></div>

    <div app-team-member-card
         name="Owen Philips, PhD"
         title="Neuroscientist, Founder & CEO"
         imageSrc="/assets/images/about-brainkey/team/Owen-Philips.webp"
         linkedin="https://www.linkedin.com/in/owenrobertphillips/"
         web="https://owenphillips.com/"
         publications="https://scholar.google.com/citations?user=lwIU9wwAAAAJ&hl=en&oi=ao"
    ></div>
  </section>

  <section class="advisors">
    <h2 class="b-page-subtitle">Trusted Advisors</h2>
    <div class="advisors__content">
      <div class="advisors__item">
        <h6>Maximilian Ibel, PhD</h6>
        <p>Board Member</p>
      </div>

      <div class="advisors__item">
        <h6>Professor Akshay Chaudhari, PhD</h6>
        <p>Stanford University</p>
      </div>

      <div class="advisors__item">
        <h6>Professor James Cole, PhD</h6>
        <p>University College London</p>
      </div>

      <div class="advisors__item">
        <h6>Professor Olivier Rascol, MD, PhD</h6>
        <p>University of Toulouse</p>
      </div>

      <div class="advisors__item">
        <h6>Edmond Knopp, MD</h6>
        <p>Neuroradiology</p>
      </div>
    </div>
  </section>

  <section class="proudly-backed">
    <h2 class="b-page-subtitle">Proudly Backed by</h2>

    <div class="proudly-backed__partners">
      <div class="proudly-backed__first-row">
        <div class="proudly-backed__image order-2 order-sm-1">
          <img src="/assets/images/about-brainkey/partners/human-longevity.webp" alt="">
        </div>

        <div class="proudly-backed__image proudly-backed__image--amino order-1 order-sm-2">
          <img src="/assets/images/about-brainkey/partners/amino-capital.webp" alt="">
        </div>

        <div class="proudly-backed__image order-3 order-sm-3">
          <img src="/assets/images/about-brainkey/partners/soma-capital.webp" alt="">
        </div>
      </div>

      <div class="proudly-backed__second-row">
        <div class="proudly-backed__image">
          <img src="/assets/images/about-brainkey/partners/longevity_tech-fund.webp" alt="">
        </div>

        <div class="proudly-backed__image">
          <img src="/assets/images/about-brainkey/partners/joyance.webp" alt="">
        </div>

        <div class="proudly-backed__image">
          <img src="/assets/images/about-brainkey/partners/y-combinator.webp" alt="">
        </div>

        <div class="proudly-backed__image">
          <img src="/assets/images/about-brainkey/partners/divergent-investments.webp" alt="">
        </div>
      </div>
    </div>
  </section>
</div>

<section class="get-started">
  <div class="b-container">
    <h3>Prioritize your brain health with BrainKey.</h3>
    <div class="d-flex justify-content-center">
      <a class="b-button" (click)="gs.navigate()">Get Started - Free</a>
    </div>
  </div>
</section>
